<template>
  <div class="negotiation-warp">
      <dl class="content-warp">
          <dt class="left">
              <img src="@/assets/img/negotiation/code.png" alt="">
              <div>
                  <h2>蔡先生</h2>
                  <h6>销售总监</h6>
              </div>
          </dt>
          <dd class="right">
            <ul>
                <li>
                    <img src="@/assets/img/negotiation/address.png" alt="">
                    <span>上海市浦东新区金苏路</span>
                </li>
                <li>
                    <img src="@/assets/img/negotiation/phone.png" alt="">
                    <span>16628562329</span>
                </li>
                <li>
                     <img src="@/assets/img/negotiation/mail.png" alt="">
                    <span>caihaowei@hot-fan.com</span>
                </li>
            </ul>
          </dd>
      </dl>
  </div>
</template>
<script>
export default {
  name: "negotiation",
  data() {
    return {

    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.negotiation-warp {
  width: 100%;
  height: 613px;
  background: url("../assets/img/negotiation/bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .content-warp{
      background-color: white;
      width: 916px;
      height: 385px;
      border-radius: 5px;
      box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.00);
      display: flex;
      align-items: center;
      .left{
          width: 439px;
          height: 235px;
          background-color: #10A867;
          margin-right: 59px;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              width:120px;
              height: 120px;
              margin-right: 38px;
              
          }
          h2{
                  font-size: 26px/*px*/;
                  font-weight: 500;
                  color: white;
              }
              h6{
                 font-size: 16px/*px*/;
                  color: white; 
                  opacity: .8;
                  margin-top: 8px;
              }
      }
      .right{
          ul{
              height: 184px;
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              li{
                display: flex; 
                align-items: center;
                img{
                    width: 33px;
                    height: 33px;
                }
                span{
                   color: #454544;
                   font-size: 18px/*px*/;
                   margin-left: 15px;
                }
              }
          }
      }
  }
}
</style>